<template>
    <div class="contact-subscription__row">
        <div class="contact-subscription__cell">
            <label class="contact-subscription__type">
                {{ subscriptionType }}
            </label>
        </div>

        <div class="contact-subscription__cell">
            <label class="contact-subscription__status">
                {{ subscriptionStatus }}
            </label>
        </div>

        <div class="contact-subscription__cell">
            <label class="contact-subscription__reason">
                {{ props.subscription.reason_text }}
            </label>
        </div>

        <div class="contact-subscription__cell">
            <label class="contact-subscription__updated">
                {{ subscriptionUpdatedAt }}
            </label>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { shortDateTimeTzSpread } from '../../../utils/date';
import { contactStatusLabelV2 } from '../../../utils/statuses-mappers-v2';
import { capitalize } from '../../../utils/helpers';

const props = defineProps({
    subscription: {
        type: Object,
        required: true,
    },
});

const subscriptionType = computed(() => capitalize(props.subscription.type));
const subscriptionStatus = computed(() => contactStatusLabelV2(props.subscription.status));
const subscriptionUpdatedAt = computed(() => shortDateTimeTzSpread(props.subscription.updated_at));
</script>

<style lang="scss">
.contact-subscription__row {
    display: grid;
    align-items: center;
    grid-template-columns: 20% 20% 30% 30%;
    font-family: var(--font-open-sans);

    &:nth-of-type(even) {
        background-color: var(--color-background);
    }
}

.contact-subscription__cell {
    padding: 16px;

    label {
        font-size: 0.875rem;
        margin: 0;
        color: var(--color-grey);
    }
}
</style>
